module.exports = __webpack_public_path__ + "img/stars-sky-img-mob.39db9865.jpg";